import PropTypes from 'prop-types';
import React from 'react';
import withProductImpressionsTracking from '../../hocs/withProductImpressionsTracking';
import truncateHtml from '../../../utils/truncateHtml';
import getCapitalizedName from '../../../utils/getCapitalizedName';

export const TrackedProductInfo = ({ short_title }) => (
  <div className="short-title"
    dangerouslySetInnerHTML={{
      __html: truncateHtml(
        getCapitalizedName(short_title), { length: 45, omission: '...' }
      )
    }}
  />
);

const decorator = withProductImpressionsTracking({
  eventParams() {
    return [
      'Shopping',
      'Impressions',
      this.props.short_title,
      { nonInteraction: true }
    ];
  },
  dataLayerParams() {
    return ['View', {
      pageModule: 'Product Card',
      slideshowComponent: 'Shop This',
      itemIndex: this.props.data_index
    }];
  },
  shouldCheckProductCarouselInteractions() {
    return true;
  },
  leftBound() {
    return this.props.leftTrackingBoundary;
  },
  rightBound() {
    return this.props.rightTrackingBoundary;
  }
});

TrackedProductInfo.propTypes = {
  data_index: PropTypes.number.isRequired,
  short_title: PropTypes.string.isRequired,
  leftTrackingBoundary: PropTypes.number.isRequired,
  rightTrackingBoundary: PropTypes.number.isRequired
};

TrackedProductInfo.defaultProps = {
  data_index: 0,
  short_title: '',
  leftTrackingBoundary: 0,
  rightTrackingBoundary: 0
};

export default decorator(TrackedProductInfo);
